export interface WorkExperienceItem {
  companyName: string;
  logoSrc: string;
  jobTitle: string;
  location: string;
  duration: string;
}

export const workExperience: WorkExperienceItem[] = [
  {
    companyName: 'VOITH Orginization',
    logoSrc: '/Images/voith1.png', // Placeholder, ensure actual logo path
    jobTitle: 'UI/UX Designer || Developer',
    location: 'Ananda Nagar, Dhumbarahi, Chabahil, Kathmandu',
    duration: '2025-Present',
  },
  {
    companyName: 'Tech Nirvana',
    logoSrc: '/Images/technirvana.png', // Placeholder
    jobTitle: 'UI/UX Designer',
    location: 'Jhamshikhel Lalitpur',
    duration: '2024-Remote',
  },
  {
    companyName: 'VeloxLabs',
    logoSrc: '/Images/hajirlogo.png', // Placeholder
    jobTitle: 'UI/UX Designer',
    location: 'Baneshwor, Kathmandu',
    duration: '2024-Past',
  },
  {
    companyName: 'SolveeTech',
    logoSrc: '/Images/solvee.png', // Placeholder
    jobTitle: 'UI/UX Designer || UI Developer',
    location: 'Kalopul, Kathmandu',
    duration: '2023-Past',
  },
]; 